module.exports = __webpack_public_path__ + "static/media/datopian-logo.a5f7af6f.png";